function limitWhitespace(input) {
  var whitespaceMaxLength = 8;

  var currentWhitespace = 0;

  input.addEventListener('keydown', function (event) {
    if (event.key === ' ' || event.key === 'Enter') {
      if (currentWhitespace >= whitespaceMaxLength) {
        event.preventDefault();
        return;
      }
      currentWhitespace += 1;
    }
    else if (event.key === 'Backspace') {
      setTimeout(function() {
        event.target.value = trimTextToMaxWhitespace(event.target.value, false);
        const regExpMatch = event.target.value.match(/\s+$/) || [];
        currentWhitespace = (regExpMatch[0] || '').length;
      });
    }
    else if (event.key.length === 1) {
      currentWhitespace = 0;
    }
  });

  function trimTextToMaxWhitespace(text, trimEnds) {
    const spaceRegExp = new RegExp(`/ {${whitespaceMaxLength},}/`, 'g');
    const newLineRegExp = new RegExp(`/\n{${whitespaceMaxLength},}/`, 'g');
    var result = text.replace(/\n +/g, '\n');

    result = result.replace(spaceRegExp, ' '.repeat(whitespaceMaxLength));

    result = result.replace(newLineRegExp, '\n'.repeat(whitespaceMaxLength));
    if (trimEnds) {
      return result.trim();
    }
    return result;
  }

  var undoValue = null;

  input.addEventListener('keydown', function(event) {
    if ((event.ctrlKey && event.key === 'z') || (event.metaKey && event.key === 'z')) {
      if (undoValue) {
        input.value = undoValue;
      }
    }
  });

  input.addEventListener('paste', function(event) {
    undoValue = input.value;
    setTimeout(function() {
      event.target.value = trimTextToMaxWhitespace(event.target.value, true);
    });
  });
}

var PROGRESS_BAR_CLASSES = {
  WARNING: 'ds-textarea__progress-bar__progress-warning',
  SUCCESS: 'ds-textarea__progress-bar__progress-success',
  DANGER: 'ds-textarea__progress-bar__progress-danger',
};

App.namespace.wrap('views.shared.ds_textarea_handler', function (textareaElement, form) {
  var id = textareaElement.getAttribute('id');
  var minLength = parseInt(textareaElement.getAttribute('data-minLength') || '0', 10);
  var maxLength = parseInt(textareaElement.getAttribute('data-maxLength'), 10);

  var lengthNotice = form.querySelector('.length-notice[data-bind="' + id + '"]');
  var progressBar = form.querySelector('.ds-textarea__progress-bar[data-bind="' + id + '"]');
  var progressBarProgress = progressBar.querySelector('.ds-textarea__progress-bar__progress');

  var minLengthNoticeContent = 'Type at least ' + minLength + ' characters';
  var maxLengthNoticeContent = 'Please shorten the text';

  function update() {
    var contentLength = textareaElement.value.length;

    lengthNotice.classList.remove('error');
    textareaElement.removeAttribute('aria-invalid');

    if (contentLength > maxLength) {
      lengthNotice.classList.add('error');
      textareaElement.setAttribute('aria-invalid', true);
      lengthNotice.innerText = maxLengthNoticeContent;
    } else if (contentLength < minLength) {
      lengthNotice.innerText = minLengthNoticeContent;
    } else {
      lengthNotice.innerText = '';
    }

    var progressBarClass = PROGRESS_BAR_CLASSES.SUCCESS;
    if (contentLength < minLength) {
      progressBarClass = PROGRESS_BAR_CLASSES.WARNING;
    }
    if (contentLength > maxLength) {
      progressBarClass = PROGRESS_BAR_CLASSES.DANGER;
    }

    if (contentLength === 0) {
      progressBar.style.display = 'none';
    } else {
      progressBar.style.display = 'block';
    }

    var progressWidth = Math.min(100, contentLength / maxLength * 100);
    progressBarProgress.classList.remove(PROGRESS_BAR_CLASSES.DANGER, PROGRESS_BAR_CLASSES.SUCCESS, PROGRESS_BAR_CLASSES.WARNING);
    progressBarProgress.classList.add(progressBarClass);

    progressBarProgress.style.width = progressWidth + '%';
  }

  update();
  textareaElement.addEventListener('input', update);
  limitWhitespace(textareaElement);
});

App.namespace.wrap('views.shared.limit_whitespace', limitWhitespace);
